module.exports = __webpack_public_path__ + "static/img/32.68d427c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/32.jpg
// module id = uWA2
// module chunks = 1